import React from "react";
import { SplitConfigSchema } from "@common/schemas/rule.schema";
import { RuleTagRow } from "../RuleTagRow";

interface Props {
    value: string;
}

export const RuleSplitAction: React.FC<Props> = ({ value }) => {
    const splits = SplitConfigSchema.safeParse(JSON.parse(value));

    if (!splits.success) {
        return null;
    }

    return (
        <RuleTagRow
            label="Split"
            type="action"
            values={[`${splits.data.splits.length} parts`]}
        />
    );
};
